import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayTaskEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/task/`
        this.webApi = new WebApi()
    }

    async changeTask (request) {
        const response = await this.webApi.post(`${this.url}save`, request)
        if (response) {
            if (!response.status_code) {
                if (!response.error) {
                    return response
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${response.status_code}`)
            }
        }
        return null
    }

    async createTask (request) {
        const response = await this.webApi.post(`${this.url}create`, request)
        if (response) {
            if (!response.status_code) {
                if (!response.error) {
                    return response
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${response.status_code}`)
            }
        }
        return null
    }

    async getTasks (arg) {
        const points = await this.webApi.post(`${this.url}list`, arg)
        // console.log('points:', points)
        if (points) {
            if (!points.status_code) {
                if (!points.error) {
                    return points
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${points.status_code}`)
            }
        }
        return null
    }
}
